import React from "react";
import * as Styled from "./styles";
import {
  TextField,
  Button,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  //Chip,
  Grow,
  Paper,
  //Modal,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useAvaliation } from "shared/providers/Avaliation";
import { IAppraisal } from "shared/types/Appraisal";
import { useAuth } from "shared/providers/auth";
import { sendAppraisal } from "requests/Appraisal";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { getAparelhos } from "requests/Aparelhos";
import { IAparelho } from "shared/types/Aparelho";
import { FaTooth } from "react-icons/fa";
import { IndicationScienceReferrals } from "components/Referrals/Indication-Science";
import { ROUTER } from "shared/constants/router";
import { IoReceiptOutline, IoCloseCircleOutline } from "react-icons/io5";

//import { Odontograma } from "components/Odontograma";

const AvaliationScreen: React.FC = () => {
  const { user } = useAuth();
  const {
    firstQuestion,
    setFirstQuestion,
    firstReason,
    setFirstReason,
    secondQuestion,
    setSecondQuestion,
    care,
    setCare,
    careReason,
    setCareReason,
    careReasonError,
    setCareReasonError,
    periodont,
    setPeriodont,
    periodontReason,
    setPeriodontReason,
    periodontReasonError,
    setPeriodontReasonError,
    cirurgy,
    setCirurgy,
    cirurgyReason,
    setCirurgyReason,
    cirurgyReasonError,
    setCirurgyReasonError,
    description,
    setDescription,
    descriptionError,
    setDescriptionError,
    //setStep,
    //odontogramaCarie,
    // setOdontogramaCarie,
    //odontogramaCirurgy,
    //setOdontogramaCirurgy,
    //odontogramaProblem,
    //setOdontogramaProblem,
    patientObj,
    clearAvaliationData,
  } = useAvaliation();
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [showBudgetModal, setShowBudgetModal] = React.useState<boolean>(false);

  // const [openCarie, setOpenCarie] = React.useState<boolean>(false);
  //const [openCirurgy, setOpenCirurgy] = React.useState<boolean>(false);
  //const [openProblem, setOpenProblem] = React.useState<boolean>(false);

  // Estado para controlar o modal ORTO 41
  const [openOrto41, setOpenOrto41] = React.useState<boolean>(false);
  const [orto41Completed, setOrto41Completed] = React.useState<boolean>(false);

  const [motivError, setMotivError] = React.useState<string>("");

  const [typeBrace, setTypeBrace] = React.useState<number>(0);

  const [braces, setBraces] = React.useState<IAparelho[]>([]);

  const [selectedBraceId, setSelectedBraceId] = React.useState<number | null>(
    null
  );

  const reason =
    (care ? `${careReason}` : "") +
    "|" +
    (periodont ? `${periodontReason}` : "") +
    "|" +
    (cirurgy ? `${cirurgyReason}` : "");

  const buildPayload = React.useCallback(
    (): IAppraisal => ({
      id: user && user.data && user.data.id,
      idSchedule: patientObj && patientObj.id,
      idPac: patientObj && patientObj.pac_id,
      data: [
        {
          complaint: description,
          recommendation: firstQuestion === "yes" ? "S" : "N",
          immediate: secondQuestion === "yes" ? 1 : 0,
          aparelho: typeBrace === 2 ? null : selectedBraceId,
          tipo_aparelho: typeBrace,
          ...(reason && { reason: reason }),
        },
      ],
      ...(firstReason && { obs: firstReason }),
    }),
    [
      description,
      firstQuestion,
      secondQuestion,
      typeBrace,
      selectedBraceId,
      reason,
      firstReason,
      user,
      patientObj,
    ]
  );

  const sendConsult = async () => {
    setLoading(true);

    try {
      const { status, data } = await sendAppraisal(buildPayload());

      if ([200, 201].includes(status)) {
        toast.success(data.message);
        clearAvaliationData(); // Limpar dados da avaliação
        localStorage.removeItem("personAttendance");
        localStorage.removeItem("pendingAvaliation");
        navigate("/home");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Erro ao enviar consulta:", error);
      toast.error("Ocorreu um erro ao enviar a consulta.");
    } finally {
      setLoading(false);
      setShowBudgetModal(false);
    }
  };

  const handleGenerateBudget = () => {
    const avaliacaoData = {
      type: "appraisal",
      payload: buildPayload(),
    };

    localStorage.setItem("pendingAvaliation", JSON.stringify(avaliacaoData));
    setShowBudgetModal(false);
    navigate(ROUTER.CLINICAL_BUDGET);
  };

  const handleSkipBudget = () => {
    sendConsult();
  };

  const handleContinue = () => {
    let valid = true;

    if (firstQuestion === "yes") {
      if (typeBrace === 1) {
        if (selectedBraceId === null) {
          toast.error("Selecione o tipo de aparelho e tente novamente");
          return false;
        }
      }
    }

    if (firstQuestion === "no") {
      if (firstReason.length < 19) {
        setMotivError("Motivo deve conter mais de 20 caracteres.");
        return false;
      }
    }

    if (description.length < 20) {
      setDescriptionError("A descrição deve conter mais de 20 caracteres.");
      valid = false;
    } else {
      setDescriptionError("");
    }

    if (care && careReason.length === 0) {
      setCareReasonError(
        "Por favor, forneça um motivo para 'Cáries extensas'."
      );
      valid = false;
    } else {
      setCareReasonError("");
    }

    if (periodont && periodontReason.length === 0) {
      setPeriodontReasonError(
        "Por favor, forneça um motivo para 'Problema periodontal'."
      );
      valid = false;
    } else {
      setPeriodontReasonError("");
    }

    if (cirurgy && cirurgyReason.length === 0) {
      setCirurgyReasonError(
        "Por favor, forneça um motivo para 'Caso cirúrgico'."
      );
      valid = false;
    } else {
      setCirurgyReasonError("");
    }

    if (valid) {
      if (Number(patientObj?.dentista_orcamento) === 1) {
        setShowBudgetModal(true);
      } else {
        sendConsult();
      }
    }
  };

  const handleAparelhos = React.useCallback(async () => {
    try {
      const { status, data } = await getAparelhos({ userId: user.data.id });

      if ([200, 201].includes(status)) {
        setBraces(data.data);
      }

      /*setBraces([
        {
          aparelho_id: 11,
          aparelho_nome: "Convencional",
        },
        {
          aparelho_id: 12,
          aparelho_nome: "Ceramico",
        },
        {
          aparelho_id: 13,
          aparelho_nome: "Autoligado",
        },
        {
          aparelho_id: 14,
          aparelho_nome: "Safira",
        },
      ]);*/
    } catch (error) {
      console.log(error);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    handleAparelhos();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Styled.Box>
      <Styled.BoxDescription>
        <h5>Queixa principal</h5>
        <TextField
          minRows={5}
          maxRows={5}
          multiline
          value={description}
          onChange={(e) => {
            setDescription(e.target.value);
            if (e.target.value.length > 19) {
              setDescriptionError("");
            }
          }}
          error={!!descriptionError}
          helperText={descriptionError}
        />
      </Styled.BoxDescription>

      <Styled.BoxDescription>
        <Typography variant="h5">
          Indicação para Tratamento Ortodôntico?
        </Typography>
        <Styled.BoxButtons>
          <Button
            variant={firstQuestion === "no" ? "contained" : "outlined"}
            onClick={() => {
              setFirstQuestion("no");
              setSelectedBraceId(null);
              setTypeBrace(0);
            }}
          >
            NÃO
          </Button>
          <Button
            variant={firstQuestion === "yes" ? "contained" : "outlined"}
            onClick={() => {
              setFirstQuestion("yes");
              setSelectedBraceId(null);
              setTypeBrace(0);
            }}
          >
            SIM
          </Button>
        </Styled.BoxButtons>
      </Styled.BoxDescription>

      {firstQuestion === "no" && (
        <TextField
          label="Motivo"
          value={firstReason}
          onChange={(e) => {
            setFirstReason(e.target.value);
            if (e.target.value.length > 20) {
              setMotivError("");
            }
          }}
          error={!!motivError}
          helperText={motivError}
          fullWidth
          margin="normal"
        />
      )}

      {firstQuestion === "yes" && (
        <div>
          <Styled.BoxDescription>
            <Typography variant="h5">
              Início Imediato do Tratamento Ortodôntico?
            </Typography>
            <Styled.BoxButtons>
              <Button
                variant={secondQuestion === "no" ? "contained" : "outlined"}
                onClick={() => setSecondQuestion("no")}
              >
                NÃO
              </Button>
              <Button
                variant={secondQuestion === "yes" ? "contained" : "outlined"}
                onClick={() => setSecondQuestion("yes")}
              >
                SIM
              </Button>
            </Styled.BoxButtons>
          </Styled.BoxDescription>

          {secondQuestion === "no" && (
            <>
              <Styled.BoxIndication>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox checked={care} onClick={() => setCare(!care)} />
                    }
                    label="Cáries extensas"
                  />
                </FormGroup>
                {care && (
                  <TextField
                    label="Motivo"
                    value={careReason}
                    onChange={(e) => setCareReason(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                    error={!!careReasonError}
                    helperText={careReasonError}
                  />
                )}

                {/*care && (
                  <Button onClick={() => setOpenCarie(true)}>
                    Abrir Odontograma
                  </Button>
                )

                <Modal open={openCarie} onClose={() => setOpenCarie(false)}>
                  <Odontograma
                    onClose={() => setOpenCarie(false)}
                    selected={odontogramaCarie}
                    setSelected={setOdontogramaCarie}
                    subtitle="Cáries Extensas"
                  />
                </Modal>*/}
              </Styled.BoxIndication>

              <Styled.BoxIndication>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={periodont}
                        onClick={() => setPeriodont(!periodont)}
                      />
                    }
                    label="Problema periodontal"
                  />
                </FormGroup>
                {periodont && (
                  <TextField
                    label="Motivo"
                    value={periodontReason}
                    onChange={(e) => setPeriodontReason(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                    error={!!periodontReasonError}
                    helperText={periodontReasonError}
                  />
                )}

                {/*periodont && (
                  <Button onClick={() => setOpenProblem(true)}>
                    Abrir Odontograma
                  </Button>
                )

                <Modal open={openProblem} onClose={() => setOpenProblem(false)}>
                  <Odontograma
                    onClose={() => setOpenProblem(false)}
                    selected={odontogramaProblem}
                    setSelected={setOdontogramaProblem}
                    subtitle="Problema periodontal"
                  />
                </Modal>*/}
              </Styled.BoxIndication>

              <Styled.BoxIndication>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={cirurgy}
                        onClick={() => {
                          const newValue = !cirurgy;
                          setCirurgy(newValue);
                          // Abre automaticamente o formulário ORTO 41 quando marca "Caso Cirúrgico"
                          if (newValue && !orto41Completed) {
                            setOpenOrto41(true);
                          }
                        }}
                      />
                    }
                    label="Caso cirúrgico"
                  />
                </FormGroup>
                {cirurgy && (
                  <>
                    <TextField
                      label="Motivo"
                      value={cirurgyReason}
                      onChange={(e) => setCirurgyReason(e.target.value)}
                      fullWidth
                      margin="normal"
                      required
                      error={!!cirurgyReasonError}
                      helperText={cirurgyReasonError}
                    />
                    
                    {/* Indicador de status do ORTO 41 e botão para preencher */}
                    <Styled.BoxOrto41>
                      {orto41Completed ? (
                        <Chip
                          label="ORTO 41 - Preenchido"
                          color="success"
                          size="small"
                        />
                      ) : (
                        <>
                          <Chip
                            label="ORTO 41 - Pendente"
                            color="warning"
                            size="small"
                          />
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => setOpenOrto41(true)}
                            sx={{ ml: 1 }}
                          >
                            Preencher ORTO 41
                          </Button>
                        </>
                      )}
                    </Styled.BoxOrto41>
                  </>
                )}

                {/*cirurgy && (
                  <Button onClick={() => setOpenCirurgy(true)}>
                    Abrir Odontograma
                  </Button>
                )

                <Modal open={openCirurgy} onClose={() => setOpenCirurgy(false)}>
                  <Odontograma
                    onClose={() => setOpenCirurgy(false)}
                    selected={odontogramaCirurgy}
                    setSelected={setOdontogramaCirurgy}
                    subtitle="Caso cirúrgico"
                  />
                </Modal>
                */}
              </Styled.BoxIndication>
            </>
          )}
        </div>
      )}

      {firstQuestion === "yes" && (
        <Styled.BoxDescription>
          <Typography variant="h5">
            Qual tipo de aparelho é indicado?
          </Typography>
          <Styled.BoxButtons>
            <Button
              variant={typeBrace === 1 ? "contained" : "outlined"}
              onClick={() => setTypeBrace(1)}
            >
              Fixo
            </Button>
            <Button
              variant={typeBrace === 2 ? "contained" : "outlined"}
              onClick={() => {
                setTypeBrace(2);
                setSelectedBraceId(null);
              }}
            >
              Invisível
            </Button>
          </Styled.BoxButtons>
        </Styled.BoxDescription>
      )}

      {typeBrace === 1 && (
        <Styled.BoxBraces
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            justifyContent: "center",
          }}
        >
          {braces.map((brace) => {
            const isSelected = selectedBraceId === brace.id_aparelho;
            return (
              <Grow in timeout={300} key={brace.id_aparelho}>
                <Paper
                  onClick={() => setSelectedBraceId(brace.id_aparelho)}
                  elevation={isSelected ? 6 : 1}
                  sx={{
                    width: 70,
                    height: 60,
                    p: 2,
                    borderRadius: 3,
                    textAlign: "center",
                    backgroundColor: isSelected ? "#d0f0fd" : "#fff",
                    border: isSelected ? "2px solid #0288d1" : "1px solid #ccc",
                    transition: "0.2s",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    "&:active": {
                      transform: "scale(0.97)",
                    },
                  }}
                >
                  <FaTooth
                    size={28}
                    color={isSelected ? "#0288d1" : "#757575"}
                  />
                  <Typography
                    variant="subtitle1"
                    fontSize="14px"
                    fontWeight={500}
                    mt={1}
                  >
                    {brace.nome_aparelho}
                  </Typography>
                </Paper>
              </Grow>
            );
          })}
        </Styled.BoxBraces>
      )}

      {(firstQuestion === "no" ||
        secondQuestion === "yes" ||
        secondQuestion === "no") && (
        <Styled.BtnFixed>
          <Button fullWidth onClick={handleContinue} disabled={loading}>
            {loading ? <CircularProgress /> : "Finalizar"}
          </Button>
        </Styled.BtnFixed>
      )}

      {/* Modal ORTO 41 - Ciência de indicação cirúrgica */}
      <IndicationScienceReferrals
        open={openOrto41}
        close={() => setOpenOrto41(false)}
        pacId={patientObj?.pac_id}
        onCompleteOrto={() => {
          setOrto41Completed(true);
        }}
        emailPatient={patientObj?.pac_email}
      />

      <Dialog
        open={showBudgetModal}
        onClose={() => !loading && setShowBudgetModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            p: 1,
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", pb: 1 }}>
          <IoReceiptOutline
            size={48}
            color="#16a34a"
            style={{ marginBottom: 8 }}
          />
          <Typography variant="h5" component="div" sx={{ fontWeight: "bold" }}>
            Orçamento Clínico
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", pb: 2 }}>
          <Typography variant="body1" sx={{ color: "#64748b", mb: 2 }}>
            Deseja gerar um orçamento clínico para este paciente antes de
            finalizar a avaliação?
          </Typography>
          <Typography variant="body2" sx={{ color: "#94a3b8" }}>
            Você poderá adicionar procedimentos clínicos como restaurações,
            limpezas, extrações, etc.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ flexDirection: "column", gap: 1, px: 3, pb: 3 }}>
          <Button
            fullWidth
            variant="contained"
            color="success"
            startIcon={<IoReceiptOutline />}
            onClick={handleGenerateBudget}
            disabled={loading}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              py: 1.5,
              fontSize: "1rem",
            }}
          >
            Sim, gerar orçamento clínico
          </Button>
          <Button
            fullWidth
            variant="outlined"
            color="inherit"
            startIcon={<IoCloseCircleOutline />}
            onClick={handleSkipBudget}
            disabled={loading}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              py: 1.5,
              fontSize: "1rem",
              color: "#64748b",
              borderColor: "#e2e8f0",
            }}
          >
            {loading ? "Finalizando..." : "Não, apenas finalizar"}
          </Button>
        </DialogActions>
      </Dialog>

    </Styled.Box>
  );
};

export { AvaliationScreen };
